module.exports = __webpack_public_path__ + "img/news3-6.1d4c94d8.png";